import { gql } from '@apollo/client';

export const fetchUpcomingRenewalsForTransactionAccount = gql`
  query fetchUpcomingRenewalsForTransactionAccountInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          baseProduct
          transactionAccountId
          entitlementNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          cloudSiteId
          cloudSiteHostname
          orgName
          orgProvisionedResourceType
          createdDate
          offering {
            id
            name
          }
        }
      }
    }
  }
`;
